import type { AuthRole } from './model.js';
import { can } from '../../authorization/policy.js';
import { profileDefinition, type OperationalProfile } from '../../authorization/model.js';

export const NAVIGATION_ITEMS = [
  'OVERVIEW',
  'CLIENTS',
  'BACKUPS',
  'SERVERS',
  'MICROSOFT_365',
  'THREECX',
  'ONBOARDING',
  'PROJECTS',
  'SETTINGS',
  'PLATFORM_ADMIN',
] as const;

export type NavigationItem = (typeof NAVIGATION_ITEMS)[number];

export function canAccessNavigation(role: AuthRole, item: NavigationItem): boolean {
  if (item === 'PLATFORM_ADMIN') return can(role, 'ACCESS_PLATFORM_ADMIN');
  if (item === 'SETTINGS') return can(role, 'MANAGE_OPERATIONAL_SETTINGS');
  return can(role, 'VIEW_OPERATIONAL');
}

export function orderedOperationalNavigation(
  profile: OperationalProfile,
): readonly NavigationItem[] {
  return [
    ...profileDefinition(profile).dashboardOrder,
    'SETTINGS',
    'PLATFORM_ADMIN',
  ];
}
